<div class="zk-flex zk-flex-col zk-gap-4 zk-mt-10">
	<div class="zk-flex zk-gap-1">
		<p class="contacts-filter-title" freud-typography fontType="h4BoldAuto">
			{{
				type === 'clinical_severity'
					? ('PAGES.CLIENTS.TABLES.FILTER.CLINICAL_SEVERITY.TITLE' | translate)
					: ('PAGES.CLIENTS.TABLES.FILTER.LIFE_QUALITY.TITLE' | translate)
			}}
		</p>
		<div
			freud-tooltip
			[tooltipLabel]="
				type === 'clinical_severity'
					? ('PAGES.CLIENTS.TABLES.FILTER.CLINICAL_SEVERITY.TOOLTIP'
					  | translate)
					: ('PAGES.CLIENTS.TABLES.FILTER.LIFE_QUALITY.TOOLTIP' | translate)
			"
		>
			<span class="freud-icon freud-icon-info-circle"></span>
		</div>
	</div>
	<div *ngFor="let option of options">
		<freud-checkbox
			[ngModel]="isChecked(option.level)"
			[label]="option.levelDescription"
			[id]="option.level"
			[value]="option.level"
			(onChange)="onCheckChange({$event, value: option.level})"
		></freud-checkbox>
	</div>
</div>
